import { z } from 'zod';
export const LocationHistoryRecordTypeSchema = z.enum(['movement', 'stationary']);
export const LocationMotionStateSchema = z.enum(['MOVING', 'STATIONARY']);
/** Smoothed position sample used by the ingest pipeline. */
export const SmoothedPositionSampleSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number().optional(),
    layerId: z.number().optional(),
    timestampMs: z.number().int().nonnegative(),
});
//# sourceMappingURL=location-telemetry-pipeline.schema.js.map